import React, { useEffect, useState } from "react"

import "./step-three-your-cart.scss"
import { useStaticQuery, graphql } from "gatsby"
import ModalRedeemSuccess from "../modal-redeem-success/modal-redeem-success"
import WhatsappRedeemLink from "../../atoms/whatsapp-redeem-link/whatsapp-redeem-link"
import Button from "../../../shared/components/atoms/button/button"
import MyPointsService from "../../../shared/services/my-points-service"
import Loader from "react-loader-spinner"
import { createListPrizePayload } from "../../../shared/utils/payloadDatalayer"
import { encryptUserInfo } from "../../../shared/utils/encryptUserInfo"
import { pushDataLayerEvent, pushGtagEvent } from "../../../shared/utils/metricManagementUtil"
import { getTextOneRedeemInfo, getTextTwoRedeemInfo } from "../../../utils/getPointMessages"

const StepThreeYourCart = props => {
  const resultQuery = useStaticQuery(
    graphql`
      query PDF_QUERY {
        allContentfulNolHomeTercerNivel(
          filter: {
            pdfServientrega: { title: { eq: "pdf-puntos-servientrega" } }
          }
        ) {
          nodes {
            node_locale
            pdfServientrega {
              file {
                url
              }
              title
            }
          }
        }
      }
    `
  )

  const pdfDownLoad = resultQuery.allContentfulNolHomeTercerNivel.nodes.filter(
    e => e.node_locale === process.env.LOCALE
  )[0].pdfServientrega.file.url

  const { redemptionId, pointsPerGifts, pointsPerKeys, setModalActive } = props

  const [loadPdf, setloadPdf] = useState(false)

  const [tapActive, settapActive] = useState(0)
  const [isDownloandPDF, setIsDownloandPDF] = useState(false)

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const handleDownLoad = e => {
    setloadPdf(true)

    e.preventDefault()

    //var userInfo = JSON.parse(localStorage.getItem("USER_INFO"));
    var tokenId = JSON.parse(localStorage.getItem("TOKEN_INFO")).idToken

    var config = {
      responseType: "blob",
      headers: {
        Authorization: tokenId,
      },
    }

    MyPointsService.downLoadPdf(redemptionId, config)
      .then(res => {
        const file = new Blob([res.data], { type: "application/pdf" })
        const fileURL = window.URL.createObjectURL(file)
        const link = document.createElement("a")
        link.href = fileURL
        link.download = "Redencion.pdf"
        link.click()
        setIsDownloandPDF(true)
        setloadPdf(false)
      })
      .catch(err => {
        console.log(err)
        setloadPdf(false)
      })
  }

  const handleModalActive = () => {
    localStorage.removeItem('USER_PRIZES');

    setModalActive(
      <ModalRedeemSuccess setModalClose={() => setModalActive(null)} />
    )
  }


  const onFinishDatalayer = () => {
    const prizesInfo = JSON.parse(localStorage.getItem("USER_PRIZES"))
    const items = createListPrizePayload(prizesInfo, { item_category: `Premio ${prizesInfo?.[0]?.type}` })
    let prices = 0
    items.forEach((item)=>{
      prices += parseInt(item.price, 10)
      item.price = 0
    })

    pushGtagEvent({
      event: "checkout_reclamar",
      params: {
        items,
        currency: "COP",
        coupon: null,
        value: 0,
        redemption: "Si",
        points: prices,
        user_data: userInfoEncrypt.user_data? userInfoEncrypt.user_data: '',
        log_status: userInfoEncrypt.log_status,
      },
    })
  }
  const pointsTotal = pointsPerGifts + pointsPerKeys;
  const userInfoEncrypt= encryptUserInfo()

  return (
    <div className="f-stepthree">
      <div className="f-stepthree-container">
        <div className="f-stepthree-container-summary">
          {process.env.LOCALE !== "es-CL" ?
            <>
              <p className="f-stepthree-container-summary-brand">
                Puntos por actividades de la marca:{" "}
                <span className="f-color-points">{pointsPerGifts} puntos</span>
              </p>

              {process.env.LOCALE === "es-AR" ? (
                <p className="f-stepthree-container-summary-packing">
                  Puntos que debés presentar en empaques:{" "}
                  <span className="f-color-points">{pointsPerKeys} puntos</span>
                </p>
              ) : (
                <p className="f-stepthree-container-summary-packing">
                  Puntos que debes presentar en empaques:{" "}
                  <span className="f-color-points">{pointsPerKeys} puntos</span>
                </p>
              )}
            </>
            :
            <>
              <p className="f-stepthree-container-summary-brand">
                Balance de puntos:{" "}
                <span className="f-color-points">{pointsTotal} puntos</span>
              </p>
            </>
          }


          {process.env.LOCALE === "es-CO" ? (
            <p className="f-stepthree-container-summary-info">
              Ten en cuenta la siguiente información:
            </p>
          ) : (
            <>
              {process.env.LOCALE === "es-AR" ? (
                <p className="f-stepthree-container-summary-info">
                  Para poder reclamar tu premio, es necesario que descargués el
                  siguiente formulario y que lo guardés como soporte. Una vez lo
                  hagas, debés elegir el medio por el cual querés reclamar tu
                  premio y seguir los pasos que te indicamos.
                </p>
              ) : process.env.LOCALE === "es-EC" ? (
                <p className="f-stepthree-container-summary-info">
                  Una vez realizado tu canje la información será enviada a
                  nuestro proveedor logístico, el mismo que se pondrá en
                  contacto contigo para coordinar la entrega de tu canje y la
                  recolección de los empaques correspondientes a tu canje.
                </p>
              ) : (
                <p className="f-stepthree-container-summary-info">
                  Para poder reclamar tu premio es necesario que descargues el
                  siguiente formulario. Una vez los hagas debes elegir el medio
                  por el cual quieres reclamar tu premio y seguir los pasos que
                  te indicamos.
                </p>
              )}
            </>
          )}
          <div className="f-downloadpdf-container">
            <div
              onClick={
                !loadPdf &&
                (e => {
                  pushDataLayerEvent({
                    event: "Interacciones - Mis Puntos",
                    category: "como_reclamar",
                    action: "click",
                    label: "Descargá aquí el formulario",
                    location: window.location.href,
                    user_data: userInfoEncrypt.user_data? userInfoEncrypt.user_data: '',
                    log_status: userInfoEncrypt.log_status,
                  })
                  handleDownLoad(e)
                })
              }
              className="f-downloadpdf-container-downloadform"
            >
              {process.env.LOCALE === "es-AR" ? (
                <>Descargá aquí el formulario</>
              ) : (
                <>Descarga aquí el formulario para reclamar tus premios</>
              )}

              <div className="f-icon-downloadform">
                {loadPdf ? (
                  <Loader
                    type="TailSpin"
                    color="#FF409B"
                    height={25}
                    width={25}
                  />
                ) : (
                  <span className="icon-download" />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="f-stepthree-curve-container">
        {process.env.LOCALE !== "es-CO" ? (
          process.env.LOCALE === "es-EC" ? (
            <div className="f-stepthree-container-footer">
              <div className="f-sequence-step">
                <div className="f-sequence-numbers">1</div>
                <p className="f-sequence-step-info">
                  Debes estar registrada en NosotrasOnline. Si no lo estás,
                  regístrate aquí.
                </p>
              </div>
              <div className="f-sequence-step">
                <div className="f-sequence-numbers">2</div>
                <p className="f-sequence-step-info">
                  Tener en tu banco los puntos necesarios para redimir el
                  premio, sean puntos ingresados por las claves personales de
                  tus productos Nosotras o puntos que has ganado con las
                  actividades de la marca. Recuerda que solo debes entregar al
                  gestor logístico los empaques de producto de las claves
                  personales que ingresaste.
                </p>
              </div>
              <div className="f-sequence-step">
                <div className="f-sequence-numbers">3</div>
                <p className="f-sequence-step-info">
                  Redime el premio y diligencia los formularios con tus datos personales. Ten en cuenta que con esta información enviaremos tu premio, así que debes estar segura que están correctos. Una vez realizado tu canje la información será enviada a nuestro proveedor logístico, el mismo que se pondrá en contacto contigo para coordinar la entrega de tu canje y la recolección de los empaques correspondientes a tu canje. Por favor te pedimos estar atenta los días siguientes a tu canje a las llamadas de números desconocidos ya que existirán 3 oportunidades de contacto y si no logramos contactarnos contigo en esas 3 ocasiones cerraremos tu canje y no existirá devolución de puntos ni entrega de algún otro premio.
                </p>
              </div>
              <div className="f-sequence-step">
                <div className="f-sequence-numbers">4</div>
                <p className="f-sequence-step-info">
                  El proceso con el gestor logístico puede tardar hasta 20 días hábiles.
                </p>
              </div>
              <div className="f-sequence-step">
                <div className="f-sequence-numbers">5</div>
                <p className="f-sequence-step-info">
                  Si tienes alguna inquietud acerca de este proceso por favor no dudes en comunicarte a nuestra línea de atención en Whatsapp +593987460088 que estará disponible de Lunes a Viernes 9h00 a 18h00. No aplica en los días feriados. Recuerda que esta línea solo será para inquietudes, dudas o problemas con tu canje.Al momento de la entrega de tu canje recuerda entregar los empaques de producto redimidos, nuestro proveedor logístico se encargará de verificar la cantidad de puntos entregados para hacer tu canje. RECUERDA si no entregas los empaques necesarios no te entregaremos tu premio.
                </p>
              </div>
              <div className="f-sequence-step">
                <div className="f-sequence-numbers">6</div>
                <p className="f-sequence-step-info">
                  Los premios están sujetos a disponibilidad, nuestro asesor te dirá si el premio canjeado está disponible al momento de comunicarse contigo
                </p>
              </div>
              <div className="f-remember">
                <div className="f-remember-container">
                  <div className="f-remember-container-header">
                    <span className="icon-alert f-icon-remember" />
                    <p className="f-remember-container-header-title">
                      Recuerda
                    </p>
                  </div>
                  <p className="f-remember-container-info">
                    Nuestro proveedor logístico te contactará, tendrás 3 oportunidades de contacto y si no logramos contactarte cerraremos tu canje.
                  </p>
                </div>
              </div>
            </div>
          ) : process.env.LOCALE === "es-CL" ? (
            <div className="f-stepthree-container-footer">
              <div className="f-sequence-step">
                <div className="f-sequence-numbers">1</div>
                <p className="f-sequence-step-info">
                  {getTextOneRedeemInfo(process.env.LOCALE)}
                </p>
              </div>
              <div className="f-sequence-step">
                <div className="f-sequence-numbers">2</div>
                <p className="f-sequence-step-info">
                  {getTextTwoRedeemInfo(process.env.LOCALE)}
                </p>
              </div>
              <div className="f-sequence-step">
                <div className="f-sequence-numbers">3</div>
                <p className="f-sequence-step-info">
                  Canjea los puntos por el premio y completa el formulario con tus datos personales. Ten en cuenta que con esta información enviaremos tu premio, así que debes estar segura de que estén correctos. Los premios serán enviados mediante correo con lo cual se hará el intento de entregarlo la cantidad de veces que el correo tenga predeterminado, pero si los datos son incorrectos, el premio no se volverá a enviar.
                </p>
              </div>
              <div className="f-sequence-step">
                <div className="f-sequence-numbers">4</div>
                <p className="f-sequence-step-info">
                  Recuerda guardar tu formulario de canje y estar atenta a las llamadas de nuestro proveedor logístico para coordinar la entrega de tu premio.
                </p>
              </div>
              <div className="f-remember">
                <div className="f-remember-container">
                  <div className="f-remember-container-header">
                    <span className="icon-alert f-icon-remember" />
                    <p className="f-remember-container-header-title">
                      Recuerda
                    </p>
                  </div>
                  <p className="f-remember-container-info">
                    Después de haber terminado todo el proceso por esta línea,
                    El proceso de entrega puede durar hasta 10 días hábiles desde que nuestro proveedor logístico Opus2 se comunique contigo.
                  </p>
                </div>
              </div>
            </div>
          ) : (
            <div className="f-stepthree-container-footer">
              <div className="f-sequence-step">
                <div className="f-sequence-numbers">1</div>
                <p className="f-sequence-step-info">
                  Envía una imagen de cada empaque por separado y el formulario
                  siguiendo estos pasos:
                  <br /> <br />
                  Escribe a la línea para atención de{" "}
                  <b>
                    Whatsapp <WhatsappRedeemLink />
                  </b>{" "}
                  que hemos autorizado y sigue las instrucciones que la asesora
                  te dará, <b>¡súper importante!</b>{" "}
                  {process.env.LOCALE === "es-EC" ? (
                    <>
                      Es necesario que envíes las fotos de tus empaques de la
                      siguiente manera: una foto de la parte frontal del empaque
                      donde deberás colocar con un marcador permanente{" "}
                      <b>los últimos 4 dígitos del código del pedido </b>
                      que podrás encontrar en el formulario que acabaste de
                      redimir, otra foto de la <b>clave personal</b> del empaque
                      y otra de los puntos.
                    </>
                  ) : (
                    <>
                      Que envíes la foto de cada empaque por separado de esta
                      manera: en el frente con un marcador permanente pongas{" "}
                      <b>los últimos 4 dígitos del código del pedido</b> del
                      formulario que acabaste de redimir, otra foto de la{" "}
                      <b>clave personal</b> y otra de los puntos.
                    </>
                  )}
                </p>
              </div>
              <div className="f-sequence-step">
                <div className="f-sequence-numbers">2</div>
                <p className="f-sequence-step-info">
                  La línea de Whatsapp estará disponible de{" "}
                  <b>
                    {process.env.LOCALE === "es-EC"
                      ? "Lunes a Viernes de 8:30 a.m a 01:00 p.m y de 02:00 p.m a 05:30 p.m"
                      : "Lunes a Viernes de 8:00 a.m a 12:00 p.m y de 01:00 p.m a 06:00 p.m"}
                  </b>
                  . No aplica en los días{" "}
                  {process.env.LOCALE === "es-EC" ? "feriados" : "festivos"}.
                  Recuerda que esta línea solo será para el envío de tus
                  empaques y el formulario.
                </p>
              </div>
              <div className="f-sequence-step">
                <div className="f-sequence-numbers">3</div>
                <p className="f-sequence-step-info">
                  Los premios están sujetos a disponibilidad, nuestra asesora te
                  dirá si lo están o no al momento de comunicarte.
                </p>
              </div>
              <div className="f-sequence-step">
                <div className="f-sequence-numbers">4</div>
                <p className="f-sequence-step-info">
                  Te invitamos a que guardes tus empaques pues pronto
                  habilitaremos los puntos de entrega para que los devuelvas, le
                  hagamos bien al planeta y sigamos apoyando la economía
                  circular.
                </p>
              </div>
              <div className="f-remember">
                <div className="f-remember-container">
                  <div className="f-remember-container-header">
                    <span className="icon-alert f-icon-remember" />
                    <p className="f-remember-container-header-title">
                      Recuerda
                    </p>
                  </div>
                  <p className="f-remember-container-info">
                    Después de haber terminado todo el proceso por esta línea,
                    el envío de tus premios puede tardar hasta 20 días hábiles.
                  </p>
                </div>
              </div>
            </div>
          )
        ) : (
          <div className="f-stepthree-container-footer">
            {process.env.LOCALE !== "es-AR" && (
              <div className="f-stepthree-container-footer-container">
                <Button
                  className={
                    "f-icon-taps" +
                    (tapActive === 0 ? " primary-pink" : " secondary-pink")
                  }
                  title={
                    process.env.LOCALE === "es-CO"
                      ? "Servientrega"
                      : "Correspondencia"
                  }
                  onClick={e => {
                    e.preventDefault()
                    pushDataLayerEvent({
                      event: "Interacciones - Mis Puntos",
                      category: "como_reclamar",
                      action: "click",
                      label: process.env.LOCALE === "es-CO" ? "servientrega" : "correspondencia",
                      location: window.location.href,
                      user_data: userInfoEncrypt.user_data? userInfoEncrypt.user_data: '',
                      log_status: userInfoEncrypt.log_status,
                    })
                    settapActive(0)
                  }}
                />
                <Button
                  className={
                    "f-icon-taps" +
                    (tapActive === 1 ? " primary-pink" : " secondary-pink")
                  }
                  title="Famitiendas"
                  onClick={e => {
                    e.preventDefault()
                    pushDataLayerEvent({
                      event: "Interacciones - Mis Puntos",
                      category: "como_reclamar",
                      action: "click",
                      label: "Famitiendas",
                      location: window.location.href,
                      user_data: userInfoEncrypt.user_data? userInfoEncrypt.user_data: '',
                      log_status: userInfoEncrypt.log_status,
                    })
                    settapActive(1)
                  }}
                />
              </div>
            )}

            {tapActive === 0 && (
              <>
                <div className="f-sequence-step">
                  <div className="f-sequence-numbers">1</div>
                  {process.env.LOCALE === "es-CO" ? (
                    <p className="f-sequence-step-info">
                      Imprime dos veces el formulario.{" "}
                    </p>
                  ) : (
                    <>
                      {process.env.LOCALE === "es-AR" ? (
                        <p className="f-sequence-step-info">
                          Una vez verifiquemos que tus datos personales estén
                          completos y que los puntos correspondan al premio que
                          elegiste, lo enviaremos a la dirección colocada en el
                          formulario. Recordá que solo debés presentar los
                          empaques de las claves personales que ingresaste si te
                          lo solicitamos.
                        </p>
                      ) : (
                        <p className="f-sequence-step-info">
                          Envía por correspondencia el formulario junto con los
                          empaques completos de tus productos Nosotras a la
                          siguiente dirección: Tiendas Nosotras. Destinatario:
                          Tienda Nosotras. Dirección en Quito: Tadeo Benítez
                          Oe1-807 y Joaquín Mancheno. Dirección en Guayaquil:
                          Av. De las Américas y Eleodoro Arboleda Edificio
                          Mecanos 3er Piso, oficina 304.
                          <br />
                          <br />
                          Una vez verifiquemos que tus datos personales estén
                          completos y que los puntos correspondan al premio que
                          elegiste lo enviaremos a la dirección colocada en el
                          formulario.
                        </p>
                      )}
                    </>
                  )}
                </div>
                {process.env.LOCALE === "es-CO" ? (
                  <div className="f-sequence-step">
                    <div className="f-sequence-numbers">2</div>
                    <p className="f-sequence-step-info">
                      Marca el sobre en el que llevarás tus empaques con:
                      nombre,{" "}
                      {process.env.LOCALE === "es-PR" ? "municipio" : "ciudad"},
                      dirección, teléfono y un texto que diga “Programa Puntos
                      Nosotras” y adjunta uno de los formularios.
                    </p>
                  </div>
                ) : null}
                {process.env.LOCALE === "es-CO" ? (
                  <div className="f-sequence-step">
                    <div className="f-sequence-numbers">3</div>
                    <div className="f-sequence-step-message">
                      <p className="f-sequence-step-desc">
                        Llévalo a un punto{" "}
                        <span className="f-servientrega">
                          Servientrega autorizado
                        </span>{" "}
                        de tu{" "}
                        {process.env.LOCALE === "es-PR"
                          ? "municipio"
                          : "ciudad"}
                        .{" "}
                        <a
                          href={pdfDownLoad}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="f-meet-then-here"
                        >
                          Conócelos aquí.
                        </a>
                      </p>
                    </div>
                  </div>
                ) : null}
                {process.env.LOCALE === "es-CO" ? (
                  <div className="f-sequence-step">
                    <div className="f-sequence-numbers">4</div>
                    <p className="f-sequence-step-info">
                      El otro formulario debes mostrárselo a la persona que
                      recibe tu sobre en Servientrega, para que le ponga el
                      sello de recibido y este servirá como prueba de la entrega
                      de los empaques.
                    </p>
                  </div>
                ) : null}
                <div className="f-remember">
                  <div className="f-remember-container">
                    <div className="f-remember-container-header">
                      <span className="icon-alert f-icon-remember" />

                      {process.env.LOCALE === "es-AR" ? (
                        <p className="f-remember-container-header-title">
                          Recordá
                        </p>
                      ) : (
                        <p className="f-remember-container-header-title">
                          Recuerda
                        </p>
                      )}
                    </div>
                    {process.env.LOCALE === "es-CO" ? (
                      <p>La entrega de tus empaques es totalmente gratis.</p>
                    ) : null}

                    {process.env.LOCALE === "es-AR" ? (
                      <p className="f-remember-container-info">
                        El envío de tus premios puede tardar hasta 30 días hábiles.
                      </p>
                    ) : (
                      <p className="f-remember-container-info">
                        El envío de tus premios puede tardar hasta 20 días hábiles
                        después de haber recibido los empaques en la bodega.
                      </p>
                    )}
                  </div>
                </div>
              </>
            )}

            {tapActive === 1 && (
              <>
                <div className="f-sequence-step">
                  <div className="f-sequence-numbers">1</div>
                  {process.env.LOCALE === "es-CO" ? (
                    <p className="f-sequence-step-info">
                      Imprime solo un formulario.
                    </p>
                  ) : (
                    <p className="f-sequence-step-info">
                      Imprime el formulario con tus datos personales y trae
                      contigo los empaques.
                    </p>
                  )}
                </div>
                <div className="f-sequence-step">
                  <div className="f-sequence-numbers">2</div>
                  <div className="f-sequence-step-message">
                    <div className="f-famitienda">
                      {process.env.LOCALE === "es-CO" ? (
                        <>
                          <p className="f-search-famitienda">
                            Busca tu famitienda más cercana:
                          </p>
                          <p className="f-sequence-step-desc">
                            <span className="f-servientrega">Pier 30:</span>{" "}
                            Lunes a viernes de 8:00 a.m. a 6:40 p.m. y los
                            sábados de 8:00 a.m. a 3:40 p.m.{" "}
                          </p>
                          <p className="f-oriental">
                            <span className="f-servientrega"> Oriental: </span>{" "}
                            Lunes a viernes de 11:00 a.m. a 12:50 p.m. y de 1:30
                            p.m. a 5:00 p.m. y los sábados de 9:00 a.m. a 11:50
                            a.m. y de 12:30 p.m. a 3:00 p.m
                          </p>
                          <p>
                            Si llegas a la Famitienda{" "}
                            <span className="f-servientrega">
                              {" "}
                              y tu premio ya no está disponible,{" "}
                            </span>{" "}
                            debes elegir otro que sí esté y que cumpla con el
                            número de puntos que cuesta el que habías
                            seleccionado anteriormente.
                          </p>
                        </>
                      ) : (
                        <>
                          <p className="f-search-famitienda">
                            ¡Deberás entregar todo junto en la Famitienda más
                            cercana!
                          </p>
                          <p className="f-sequence-step-desc">
                            <span className="f-servientrega">
                              Famitienda Quito:
                            </span>{" "}
                            Tadeo Benítez Oe1-807 y Joaquín Mancheno.{" "}
                          </p>
                          <p className="f-oriental">
                            <span className="f-servientrega">
                              {" "}
                              Famitienda Guayaquil:{" "}
                            </span>{" "}
                            Av. De las Américas y Eleodoro Arboleda Edificio
                            Mecanos 3er Piso, oficina 304.
                          </p>
                          <p>
                            Si llegas a la Famitienda{" "}
                            <span className="f-servientrega">
                              {" "}
                              y tu premio ya no está disponible,{" "}
                            </span>{" "}
                            debes elegir otro que sí esté y que cumpla con el
                            número de puntos que cuesta el que habías
                            seleccionado anteriormente.
                          </p>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <div className="f-sequence-step">
                  <div className="f-sequence-numbers">3</div>
                  <p className="f-sequence-step-info">
                    Lleva el formulario juntos con los empaques y entrégalos a
                    una de nuestras asesoras. Ellas te entregarán tu premio de
                    manera inmediata.
                  </p>
                </div>
                <div className="f-remember">
                  <div className="f-remember-container">
                    <div className="f-remember-container-header">
                      <span className="icon-alert f-icon-remember" />
                      <p className="f-remember-container-header-title">
                        Recuerda
                      </p>
                    </div>
                    <p className="f-remember-container-info">
                      {process.env.LOCALE === "es-CO"
                        ? "Válido únicamente para la ciudad de Medellín."
                        : ""}{" "}
                      Los premios están sujetos a disponibilidad en la
                      Famitienda.
                    </p>
                  </div>
                </div>
              </>
            )}
          </div>
        )}
        <div className="f-stepthree-container-finally">
          <button
            className="primary-pink f-btn-finally"
            disabled={!isDownloandPDF ? true : false}
            onClick={e => {
              e.preventDefault()
              onFinishDatalayer()
              handleModalActive()
              pushDataLayerEvent({
                event: "Interacciones - Mis Puntos",
                category: "como_reclamar",
                action: "click",
                label: "Finalizar pedido",
                location: window.location.href,
                user_data: userInfoEncrypt.user_data? userInfoEncrypt.user_data: '',
                log_status: userInfoEncrypt.log_status,
              })
            }}
          >
            Finalizar pedido
          </button>
        </div>
      </div>

    </div>
  )
}

export default StepThreeYourCart
